// Pure helper — no React/axios imports so it can be tested without mocking

/**
 * Builds the `entries` array for POST /api/v1/plannings/{id}/grade-batch/
 * (TASK-11 §8 contract).
 *
 * @param {Array} presentStudents  - Roster entries with attendance_status === true
 * @param {Object} scores          - Map studentId → { score, hours, participation }
 * @param {number} defaultHours    - Hours to use when not overridden per-student
 */
function buildBatchEntries(presentStudents, scores, defaultHours) {
  return presentStudents.map((entry) => {
    const student = entry.student ?? entry;
    const s = scores[student.id] ?? {};
    return {
      student: student.id,
      score: s.score ?? 3,
      hours: s.hours ?? defaultHours ?? 1.0,
      participation: s.participation ?? null,
    };
  });
}

export { buildBatchEntries };
